import { notification as notificationCore } from '@breezeway/brzw-react-core';

const {
  actions: { addToast },
} = notificationCore;

const successToastColor = '#23BC7A';
const errorToastColor = '#FF6464';

/**
 * @param {String} title
 * @param {String} text
 * @param {Object} additionalOptions
 */
export const addSuccessToast = (title = 'Success', text = '', additionalOptions = {}) => dispatch =>
  dispatch(
    addToast({
      color: successToastColor,
      text,
      title,
      withStyleguide: true,
      ...additionalOptions,
    }),
  );

/**
 * @param {String} title
 * @param {String} text
 * @param {Object} additionalOptions
 */
export const addErrorToast = (
  title = 'Error',
  text = 'Something went wrong.',
  additionalOptions = {},
) => dispatch =>
  dispatch(
    addToast({
      color: errorToastColor,
      text,
      title,
      withStyleguide: true,
      ...additionalOptions,
    }),
  );
